<template>
  <li class="km__list__element--modules">
    <label class="km__label--text">{{ text }} <span v-if="optional==='true'">({{ $t("km_optional") }})</span></label>
    <input :class="{error:error}" class="km__input--standard" type="text" :value="modelValue"
           @input="$emit('update:modelValue', $event.target.value)">
  </li>
</template>

<script lang="ts" setup>
const props = defineProps(
    {
      text: String, modelValue: String, optional: String, error: Boolean
    }
);
</script>

<style scoped lang="scss">
.km__list__element--modules {
  margin-bottom: 20px;
}

.km__label--text {
  margin-bottom: 5px;
}
</style>